import { render, staticRenderFns } from "./UpdateProfileOverlay.vue?vue&type=template&id=350f5020&scoped=true"
import script from "./UpdateProfileOverlay.vue?vue&type=script&lang=js"
export * from "./UpdateProfileOverlay.vue?vue&type=script&lang=js"
import style0 from "./UpdateProfileOverlay.vue?vue&type=style&index=0&id=350f5020&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350f5020",
  null
  
)

export default component.exports